import React from 'react';
import {Trans, withTranslation} from "react-i18next";
import {Link} from "react-router-dom";

let FormMessageComponent = ({messageKey, t}) => {
    return <div className="form-description">
        <p>
            <Trans i18nKey={messageKey} t={t} components={[<Link to="/" className="form-link"/>]}/>
        </p>
    </div>
};

export default withTranslation()(FormMessageComponent)